import { tickerConstants } from "../../store/actionTypes";

const initState = {
  tickerData: false,
  sidebarOpen: true,
  showFilters: true,
};

const userReducer = (state = initState, action) => {
  switch (action.type) {
    //Ticker Component
    case tickerConstants.TICKER_REQUEST:
      return {
        sidebarOpen: true,
      };
    case tickerConstants.TICKER_SUCCESS:
      return {
        ...state,
        sidebarOpen: true,
        tickerData: action.user,
      };
    case tickerConstants.TICKER_FAILURE:
      return state;
    case tickerConstants.SET_FILTER:
      return {
        ...state,
        showFilters: action.response,
      };
    case tickerConstants.SET_SIDEBAR:
      return {
        ...state,
        sidebarOpen: !(state.sidebarOpen),
      };
    default:
      return state;
  }
};

export default userReducer;
